import React from 'react';

export const VideoScreenLayout = ({ renderModal, renderFooter, children }) => {
    return (
        <div className="video-screen">
            {children}
            <div className="form__footer">{renderFooter()}</div>
            {renderModal()}
        </div>
    );
};
